import { FornecedorRepository } from "../repository/fornecedor_repository";

export class FornecedorService {
	constructor() {
		this.fornecedorRepository = new FornecedorRepository();
	}

	async buscarPorCnpj(cnpj) {
		return await this.fornecedorRepository.buscarPorCnpj(cnpj);
	}

	async buscarPorNumeroSequencial(numeroSequencial) {
		return await this.fornecedorRepository.buscarPorNumeroSequencial(numeroSequencial);
	}

	async buscarPorPropriedadeId(id) {
		return await this.fornecedorRepository.buscarPorPropriedadeId(id);
	}

	async save(data) {
		return await this.fornecedorRepository.save(data);
	}

	async update(data) {
		return await this.fornecedorRepository.update(data);
	}

	async previaImportacao(unidadeDistribuidoraId, linhas) {
		return await this.fornecedorRepository.previaImportacao(unidadeDistribuidoraId, linhas);
	}

	async importar(unidadeDistribuidoraId, linhas) {
		return await this.fornecedorRepository.importar(unidadeDistribuidoraId, linhas);
	}

	async getAll(unidadeDistribuidoraId, page, limit, search) {
		return await this.fornecedorRepository.getAll(unidadeDistribuidoraId, page, limit, search);
	}

	async getById(id) {
		return await this.fornecedorRepository.getById(id);
	}

	async changeVisibility(id) {
		return await this.fornecedorRepository.changeVisibility(id);
	}

	async getByUnidade(unidadeDistribuidoraId) {
		return await this.fornecedorRepository.getAll(unidadeDistribuidoraId, 1, 1000, "");
	}

	async getSolicitacoes(unidadeDistribuidoraId, status) {
		return await this.fornecedorRepository.getSolicitacoes(unidadeDistribuidoraId, status);
	}

	async aceitarSolicitacao(id) {
		return await this.fornecedorRepository.aceitarSolicitacao(id);
	}

	async recusarSolicitacao(id) {
		return await this.fornecedorRepository.recusarSolicitacao(id);
	}
}

export default FornecedorService;
